import axios from 'axios';
import AuthService from 'api/services/AuthService'

const baseURL = process.env.REACT_APP_API_HOST;

const axiosClient = axios.create(
  {
    baseURL: baseURL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // Credential: true,
      // 'Authorization': `Bearer ${token}`
    }
  })

  axiosClient.interceptors.request.use(
    async (config) => {
      const token = await AuthService.getAccessToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token; 
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosClient.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      if (originalConfig.url !== "/auth/refresh-tokens" && err.response) {

        // 403 — permission denied (not a token issue). The user's role may have
        // been changed mid-session. Clear the session and redirect to login.
        if (err.response.status === 403) {
          AuthService.clearSession();
          window.location.replace('/login?reason=permissions_changed');
          return Promise.reject(err);
        }

        // 401 — access token expired. Attempt a silent refresh and retry.
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          const refreshToken = await AuthService.getRefreshToken();
          if (!refreshToken) {
            AuthService.clearSession();
            window.location.replace('/login?reason=session_expired');
            return Promise.reject(err);
          }
          try {
            const res = await axiosClient.post("/auth/refresh-tokens", {
              refreshToken: refreshToken,
            });
            const { access, refresh } = res.data;
            AuthService.updateAccessToken(access.token);
            AuthService.updateResfreshAccessToken(refresh.token);
            return axiosClient(originalConfig);
          } catch (_error) {
            AuthService.clearSession();
            window.location.replace('/login?reason=session_expired');
            return Promise.reject(_error);
          }
        }
      }
      return Promise.reject(err);
    }
  );



export default axiosClient;



